import { useInfiniteQuery, useQuery } from '@tanstack/react-query';
import { merchantChatQueries } from '../api/merchant-chat-queries';

/**
 * The conversation list for the current search. Pass `false` while the drawer
 * is closed — the old drawer only fetched when open.
 */
export function useMerchantChats(username: string, enabled = true) {
  return useInfiniteQuery({ ...merchantChatQueries.list(username), enabled });
}

/**
 * One thread's messages, newest first from the wire. Pass `null` when no
 * thread is open — the query then stays idle rather than fetching chat 0.
 */
export function useMerchantThread(chatId: number | null, page: number) {
  return useQuery({
    ...merchantChatQueries.thread(chatId ?? 0, page),
    enabled: chatId !== null,
  });
}
